import {CURRENT_LOCATION} from '../actions/types';

export const setCurrentLocation = (location) => {
  return dispatch => {
    dispatch({type: CURRENT_LOCATION, payload: location});
  }
};
